import { Component, EventEmitter, Injector, Input, Output, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/common/base/base.component';
import { FormTableComponent } from 'src/app/controls/form-table/form-table.component';
import { FormService } from 'src/app/controls/form-table/form.service';
import { FormsUpdate } from 'src/app/controls/form-table/store/forms.action';
import { Form } from 'src/app/services/forms/form';
import { PpstbService } from '../ppstb.service';

@Component({
  selector: 'ppstb-side',
  templateUrl: './ppstb-side.component.html',
  styleUrls: ['./ppstb-side.component.scss']
})
export class PpstbSideComponent extends BaseComponent {
  @Input() showAllForms?: boolean;
  @Input() formsFilter?: string;

  @Output() rowSelected = new EventEmitter<Form | null>();

  @ViewChild(FormTableComponent) formTable!: FormTableComponent;

  form?: Form | null;

  constructor(
    protected override injector: Injector,
    private formService: FormService,
    private service: PpstbService
  ) {
    super(injector);
  }

  /**
   * Loads a selected PPSTB form or clears cached selection state after a repeated row click.
   * @param form Selected form, or null when the current row is deselected.
   */
  async rowSelectedEvent(form?: Form | null) {
    if (form?.id != this.form?.id || form?.editingBy != this.form?.editingBy || form?.retrievedBy?.id != this.currentUser?.id) {
      if (form) {
        form = await this.formService.getById(form.id).toPromise();
        this.service.currentDocument = form;
        if (form?.id) {
          this.form = form;
          form.retrievedBy = this.getCurrentUser();
          this.store.dispatch(new FormsUpdate(form?.id, form));
          this.rowSelected.emit(form);
        }
      }
      else {
        // Clear the side component cache so the same row can be selected again after deselection.
        this.form = null;
        this.service.currentDocument = undefined;
        this.rowSelected.emit(form);
      }
    }

  }

  formCreated(form: Form) {
    this.form = form;
    this.formTable.loadForms();
  }
}
